'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Button = require('./Button');

var _Button2 = _interopRequireDefault(_Button);

var _Actions = require('./Actions');

var _Actions2 = _interopRequireDefault(_Actions);

var _Svg = require('./Svg');

var _Svg2 = _interopRequireDefault(_Svg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Reddit = function Reddit(_ref) {
  var width = _ref.width,
      link = _ref.link,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ['width', 'link', 'title']);

  return _react2.default.createElement(
    _Button2.default,
    _extends({ title: title, width: width, href: link, onClick: link ? undefined : _Actions2.default['reddit']
    }, props),
    _react2.default.createElement(
      _Svg2.default,
      _extends({ xmlns: 'http://www.w3.org/2000/svg', width: width, height: width, viewBox: '0 0 33 33' }, props),
      _react2.default.createElement(
        'title',
        null,
        title,
        ' button'
      ),
      _react2.default.createElement(
        'g',
        { fill: 'transparent', fillRule: 'evenodd', transform: 'translate(.412 1)' },
        _react2.default.createElement('ellipse', { cx: '16.229', cy: '15.606', rx: '15.599', ry: '15.606' }),
        _react2.default.createElement(
          'g',
          { transform: 'translate(7.248 7.567)' },
          _react2.default.createElement('path', { d: 'M11.979 10.292a1.3 1.3 0 1 1-.001-2.601 1.3 1.3 0 0 1 0 2.601m.26 2.218c-.04.04-.973.99-3.082.99-2.12 0-2.968-.962-3.003-1.003a.333.333 0 0 1 .503-.435c.02.02.727.774 2.5.774 1.804 0 2.595-.78 2.603-.788a.333.333 0 0 1 .478.462m-6.99-3.52a1.3 1.3 0 1 1 2.603 0 1.3 1.3 0 0 1-2.602 0m13.126-1.44a2.12 2.12 0 0 0-2.116-2.118 2.1 2.1 0 0 0-1.396.528c-1.376-.88-3.202-1.447-5.221-1.524l1.204-3.422 3.006.72a1.73 1.73 0 0 0 1.729 1.725c.953 0 1.728-.776 1.728-1.73C17.308.777 16.533 0 15.58 0a1.73 1.73 0 0 0-1.601 1.08L10.416.228 8.938 4.43c-2.104.04-4.012.61-5.44 1.517a2.1 2.1 0 0 0-1.382-.516A2.12 2.12 0 0 0 0 7.55c0 .722.372 1.388.973 1.776a3.757 3.757 0 0 0-.057.644c0 3.056 3.703 5.543 8.255 5.543 4.553 0 8.256-2.487 8.256-5.543 0-.212-.02-.42-.054-.626a2.117 2.117 0 0 0 1.001-1.794' })
        )
      )
    )
  );
};

Reddit.defaultProps = {
  title: "Share on Reddit"
};

exports.default = Reddit;


//////////////////
// WEBPACK FOOTER
// ./~/buoy-social-share/dist/components/Reddit.js
// module id = 445
// module chunks = 168707334958949